import React, { useEffect, useMemo } from 'react';
import jwtDecode from 'jwt-decode';
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
  useHistory,
} from 'react-router-dom';
import { ClientContextProvider } from 'react-fetching-library';
import { QueryClient, QueryClientProvider } from 'react-query';
// import { ipcRenderer  } from 'electron'
import { ToastContainer } from 'react-toastify';
import { library } from '@fortawesome/fontawesome-svg-core';
import BootboxContainer from 'react-modal-promise';
import {
  fab,
  faFacebook,
  faLinkedin,
  faTwitter,
  faWhatsapp,
  faDropbox,
} from '@fortawesome/free-brands-svg-icons';
import {
  faPlusCircle,
  faFile,
  faCloudDownloadAlt,
  faExternalLinkAlt,
  faCheckCircle,
  faRedo,
  faCog,
  faSignOutAlt,
  faLock,
  faEnvelope,
  faInfoCircle,
  faEye,
  faTimesCircle,
  faBars,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faCheckSquare,
  faSearch,
  faUserPlus,
  faCheck,
  faCircle,
  faTimes,
  faQuestionCircle,
  faFolder,
  faFileAlt,
  faVideo,
  faEdit,
  faSave,
  faPaperPlane,
  faTrash,
  faFileSignature,
  faExclamationCircle,
  faUser,
  faShoppingCart,
  faUndo,
  faEllipsisH,
  faBan,
  faCoins,
  faPenSquare,
  faHandPaper,
  faPlusSquare,
  faCloudUploadAlt,
  faCrown,
  faBook,
  faBookReader,
  faStopwatch,
  faBell,
  faTag,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

import {
  faSquare as farSquare,
  faCircle as farCircle,
  faFolder as farFolder,
  faBookmark as farBookmark,
} from '@fortawesome/free-regular-svg-icons';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Spinner } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import SignUp from './pages/SignUp';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import PasswordChange from './pages/PasswordChange';
// import AccountSetup from "./pages/OldAccountSetup";
// import TemplateList from "./pages/TemplateList";
import ContractList from './pages/ContractList';
import Shop from './pages/Shop/Shop';
import Plans from './pages/Shop/Plans';
import Profile from './pages/Profile';
import ProfileSubscriptionsPage from './pages/ProfileSubscriptionsPage';
import Tutorials from './pages/Tutorials';
// import DocumentConfiguration from "./pages/DocumentConfiguration";

import { AuthProvider, useAuth } from './context/auth';
import { ThemeProvider } from './context/theme';
import { ModalsProvider } from './context/modals';
import { useThemeState } from './context/theme';
import useQueryParams from './hooks/useQuery';
import { oldClient } from './api/client';
import { useProfile } from './api/hooks/profile';
import SuccessPurchasePage from './pages/SuccessPurchase';
import AccountSuccess from './pages/AccountSuccess';
import AccountRedirect from './pages/AccountRedirect';
import CreateContract from './pages/CreateContract/CreateContract';
import CreateContractInfo from './pages/CreateContract/CreateContractInfo';
import TestamentEditor from './pages/testaments/TestamentEditor';
import EditTemplate from './pages/EditTemplate';
import CreateDocument from './pages/PublicContract';
import CreatePDFDocument from './pages/CreatePDFDocument';
import PdfViewer from './pages/PdfViewer';
import PublicForm from './pages/PublicForm';
import PublicFormHome from './pages/PublicFormHome';
import PublicFormRecover from './pages/PublicFormRecover';
import Home from './pages/Home';
import OldTemplateCatalog from './pages/OldTemplateCatalog';
import TemplateListHome from './pages/templates/TemplateListHome';
import GA from './components/GoogleAnalytics';
import { StateProvider } from './store';

import config from './config';
import DashboardAbogados from './pages/DashboardAbogados';
import DashboardIndex from './components/dashboard/dashboardIndex';
import { ELEMENT_H1 } from '@udecode/slate-plugins';
import Lawyersdashboard from './pages/DashboardAbogados';
import { PermissionChecker } from './hooks/useCheckPermission';

import Logo from './images/logo/owl-logo.svg';
import Services from './pages/Services';
library.add(
  fab,
  faPlusCircle,
  faFile,
  faCloudDownloadAlt,
  faExternalLinkAlt,
  faCheckCircle,
  faRedo,
  faCog,
  faSignOutAlt,
  faLock,
  faEnvelope,
  faInfoCircle,
  faEye,
  faTimesCircle,
  faBars,
  faChevronRight,
  faChevronLeft,
  faCheckSquare,
  farSquare,
  faCheckCircle,
  faSearch,
  faUserPlus,
  faCheck,
  faExternalLinkAlt,
  faFacebook,
  faLinkedin,
  faTwitter,
  faWhatsapp,
  faCircle,
  faDropbox,
  faTimes,
  faQuestionCircle,
  faFolder,
  faFileAlt,
  faVideo,
  faEdit,
  faSave,
  faPaperPlane,
  faTrash,
  faFileSignature,
  faExclamationCircle,
  faUser,
  faShoppingCart,
  faUndo,
  faEllipsisH,
  farCircle,
  faBan,
  faCoins,
  faPenSquare,
  farFolder,
  faChevronUp,
  faChevronDown,
  farBookmark,
  faHandPaper,
  faPlusSquare,
  faCloudUploadAlt,
  faCrown,
  faBook,
  faBookReader,
  faStopwatch,
  faBell,
  faTag,
  faExclamationTriangle,
  faVideo
);

const stripePromise = loadStripe(config.stripeApiKey);

function RoutesApp() {
  const [auth, setAuth] = useAuth();
  const theme = useThemeState();

  return (
    <ClientContextProvider client={oldClient}>
      <StateProvider>
        <ModalsProvider>
          {GA.init() && <GA.RouteTracker />}
          <Switch>
            <Route path="/signup" component={SignUp} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/password-change/:hash" component={PasswordChange} />
            <Route path="/login" component={Login} />
            <Route path="/verify/:hash" component={AccountSuccess} />
            <Route path="/auth/redirect" component={AccountRedirect} />
            <Route
              path="/forms/:formId/recover"
              component={PublicFormRecover}
            />
            <Route path="/forms/:formId/:userFormId" component={PublicForm} />
            <Route path="/forms/:formId" component={PublicFormHome} />
            <Route
              path="/account/:username/verify/:code"
              component={AccountSuccess}
            />
            <Route
              path="/account/:username/change-password/:code"
              component={PasswordChange}
            />

            <Route
              exact
              strict
              path={[
                '/public-templates/:publicTemplateId/testaments/create',
                '/templates/:templateId/testaments/create',
              ]}
              component={TestamentEditor}
            />
            <Route
              exact
              strict
              path={[
                '/public-templates/:publicTemplateId/edit',
                '/templates/:templateId/edit',
              ]}
              component={EditTemplate}
            />
            <Route
              exact
              strict
              path={['/public-templates/:publicTemplateId/documents/create']}
              component={CreateDocument}
            />

            <PrivateRoute exact path="/shop" component={Shop} />
            <PrivateRoute path="/plans" component={Plans} />
            <PrivateRoute path="/services" component={Services} />
            <ProtectedRoute
              path="/lawyers"
              component={Lawyersdashboard}
              privilege={'STARTER_LAWYER_USER'}
            />

            <Route
              exact
              path="/checkout/success"
              component={SuccessPurchasePage}
            />
            <PrivateRoute
              exact
              path="/templates/:templateId/documents"
              component={ContractList}
            />
            <PrivateRoute
              exact
              strict
              path="/documents/:documentId/edit"
              component={CreatePDFDocument}
            />
            <PrivateRoute
              exact
              strict
              path={['/documents/create']}
              component={CreatePDFDocument}
            />
            <PrivateRoute
              path={['/documents', '/contracts/editor/:contractId']}
              component={ContractList}
            />
            <PrivateRoute
              exact
              path="/templates/:templateId/pdf"
              component={PdfViewer}
            />
            <PrivateRoute exact path="/profile" component={Profile} />
            <PrivateRoute
              exact
              path="/profile/subscriptions"
              component={ProfileSubscriptionsPage}
            />
            <PrivateRoute
              exact
              strict
              path="/contracts/create"
              component={CreateContract}
            />
            <PrivateRoute
              exact
              strict
              path="/contracts/info/create"
              component={CreateContractInfo}
            />
            <PrivateRoute
              exact
              strict
              path="/templates/:templateId/documents/create"
              component={CreatePDFDocument}
            />
            <PrivateRoute
              strict
              path="/templates"
              component={TemplateListHome}
            />
            <PrivateRoute exact strict path="/pdf" component={PdfViewer} />
            <PrivateRoute exact stric path="/tutorials" component={Tutorials} />
            <PrivateRoute exact stric path="/home" component={Home} />
            <PrivateRoute exact stric path="/" component={Root} />

            {/* <PrivateRoute exact path={["/templates/request", "/templates/:templateId/request"]} component={RequestTemplate} /> */}
            {/* <Redirect exact from='/dashboard' to='/' /> */}
            {/* <PrivateRoute exact path="/documents/new" component={DocumentConfiguration} /> */}
            {/* <PrivateRoute exact strict path="/templates" component={TemplateList} /> */}
            {/* <Redirect exact from='/contract-configuration' to='/documents/new' /> */}
            <Redirect exact path="/inbox" to="/documents/inbox" />
            {/* {theme.domain === "lawyers" ? (
              <Redirect exact path="/" to="/lawyers" />
            ) : (
              <Redirect exact path="/" to="/home" />
            )} */}
          </Switch>
        </ModalsProvider>
      </StateProvider>
    </ClientContextProvider>
  );
}

function Root() {
  const { can, isLoading } = useProfile();
  const { t } = useTranslation();

  if (isLoading)
    return (
      <section id="signup" className="vh-100 d-flex">
        <div className="container align-self-center">
          <div className="card account-success align-self-center mx-auto w-50">
            <div className="card-body text-center p-lg-5 p-3 d-flex flex-column align-items-center">
              <img
                src={Logo}
                className="img-fluid w-25 mb-3"
                alt="Trato Logo"
              />
              <Spinner />
            </div>
          </div>
        </div>
      </section>
    );

  return can('STARTER_LAWYER_USER') ? (
    <Redirect exact path="/" to="/lawyers" />
  ) : (
    <Redirect exact path="/" to="/home" />
  );
}

function App() {
  const history = useHistory();
  const queryClient = useMemo(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          onError: (err) => {
            if (
              ['InvalidJWT', 'MissingJWT', 'Unauthorized'].includes(err.message)
            ) {
              localStorage.removeItem('auth');
              window.location.href = `${window.location.origin}/login`;
            }
          },
        },
      },
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Elements stripe={stripePromise}>
          <ThemeProvider>
            <AuthProvider>
              <ToastContainer
                className="toast-container"
                toastClassName="bg-light text-dark rounded success-toast-accent"
                position="top-center"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
              />
              <BootboxContainer />
              <RoutesApp />
            </AuthProvider>
          </ThemeProvider>
        </Elements>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;

function PrivateRoute({ component: Component, render, ...rest }) {
  const [auth, setAuth] = useAuth();
  const queryParams = useQueryParams();
  const hasToken = queryParams.has('token');
  const token = queryParams.get('token');
  const history = useHistory();

  // const [status, setStatus] = useState('');
  useEffect(() => {
    let authToken = {};
    let isInvalid = false;
    let user;

    try {
      if (hasToken) {
        // authToken = {
        //   token,
        //   redirectToHome: true
        // }
        // setStatus('redirecting')
      } else {
        authToken = JSON.parse(localStorage.getItem('auth'));
      }
      isInvalid = !authToken;
    } catch (err) {
      isInvalid = true;
    }

    if (isInvalid) {
      localStorage.setItem('auth', {});
      history.push('/login');
    }

    setAuth(authToken);
  }, [setAuth, history, hasToken, token]);

  return (
    <Route
      {...rest}
      render={(props) =>
        auth?.accessToken ? (
          render ? (
            render(props)
          ) : (
            <Component {...props} />
          )
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

export function ProtectedRoute({
  children,
  component: Component,
  privilege,
  ...rest
}) {
  return (
    <PrivateRoute
      {...rest}
      render={() => (
        <PermissionChecker privilege={privilege}>
          {Component ? <Component /> : children}
        </PermissionChecker>
      )}
    />
  );
}
